import { PhotoshopController } from "../photoshopController.js";
import { DatasPanelWidget } from "./datasPanelWidget.js";
import { PhotoshopWidget } from "./photoshopWidget.js";
export class FiltersWidget {
    parentElement: HTMLElement;
    photoshopController: PhotoshopController;
    dataPanelWidget: DatasPanelWidget;
    photoshopWidget: PhotoshopWidget;
    constructor(parentElement: HTMLElement, controller: PhotoshopController, dataPanelWidget: DatasPanelWidget, photoshopWidget: PhotoshopWidget) {
        this.parentElement = parentElement;
        this.photoshopController = controller;
        this.dataPanelWidget = dataPanelWidget;
        this.photoshopWidget = photoshopWidget;

        const luminosityContrastElem = document.getElementById("luminosityContrast-setting");
        if (luminosityContrastElem) {
            luminosityContrastElem.addEventListener("click", function () {
                this.luminosityContrast_settingOnClick();
                this.updateClass();
            }.bind(this));
        }

        const levelsElem = document.getElementById("levels-setting");
        if (levelsElem) {
            levelsElem.addEventListener("click", function () {
                this.levels_settingOnClick();
                this.updateClass();
            }.bind(this));
        }

        const hueSaturationElem = document.getElementById("hueSaturation-setting");
        if (hueSaturationElem) {
            hueSaturationElem.addEventListener("click", function () {
                this.hueSaturation_settingOnClick();
                this.updateClass();
            }.bind(this));
        }

        const colorBalanceElem = document.getElementById("colorBalance-setting");
        if (colorBalanceElem) {
            colorBalanceElem.addEventListener("click", function () {
                this.colorBalance_settingOnClick();
                this.updateClass();
            }.bind(this));
        }
    }

    static html() {
        return `
        <div class="col s12">
            <h4>Réglages</h4>
            <div class="row">
                <div id="luminosityContrast-setting" class="col s1 center-align" title="luminosityContrast-setting">
                    <i class="fas fa-adjust"></i>
                </div>
                <div id="levels-setting" class="col s1 center-align" title="levels-setting">
                    <i class="far fa-chart-bar"></i>
                </div>
                <div id="hueSaturation-setting" class="col s1 center-align" title="hueSaturation-setting">
                    <i class="fas fa-tint"></i>
                </div>
                <div id="colorBalance-setting" class="col s1 center-align" title="colorBalance-setting">
                    <i class="fas fa-balance-scale"></i>
                </div>
            </div>
        </div>
        <div class="col s12 divider"></div>
        `;
    }

    luminosityContrast_settingOnClick() {
        this.photoshopController.setActiveOperation('luminosityContrast');
        this.photoshopController.addOperation();
    }

    levels_settingOnClick() {
        this.photoshopController.setActiveOperation('levels');
        this.photoshopController.addOperation();
    }

    hueSaturation_settingOnClick() {
        this.photoshopController.setActiveOperation('hueSaturation');
        this.photoshopController.addOperation();
    }

    colorBalance_settingOnClick() {
        this.photoshopController.setActiveOperation('colorBalance');
        this.photoshopController.addOperation();
    }

    updateClass() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.name === 'luminosityContrast-setting') {
            const luminosityContrastSettingElem = document.getElementById("luminosityContrast-setting");
            if (luminosityContrastSettingElem) {
                luminosityContrastSettingElem.classList.add('selected-tool');
            }
        } else {
            const luminosityContrastSettingElem = document.getElementById("luminosityContrast-setting");
            if (luminosityContrastSettingElem) {
                luminosityContrastSettingElem.classList.remove('selected-tool');
            }
        }
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.name === 'levels-setting') {
            const levelsSettingElem = document.getElementById("levels-setting");
            if (levelsSettingElem) {
                levelsSettingElem.classList.add('selected-tool');
            }
        } else {
            const levelsSettingElem = document.getElementById("levels-setting");
            if (levelsSettingElem) {
                levelsSettingElem.classList.remove('selected-tool');
            }
        }
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.name === 'hueSaturation-setting') {
            const hueSaturationSettingElem = document.getElementById("hueSaturation-setting");
            if (hueSaturationSettingElem) {
                hueSaturationSettingElem.classList.add('selected-tool');
            }
        } else {
            const hueSaturationSettingElem = document.getElementById("hueSaturation-setting");
            if (hueSaturationSettingElem) {
                hueSaturationSettingElem.classList.remove('selected-tool');
            }
        }
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.name === 'colorBalance-setting') {
            const colorBalanceSettingElem = document.getElementById("colorBalance-setting");
            if (colorBalanceSettingElem) {
                colorBalanceSettingElem.classList.add('selected-tool');
            }
        } else {
            const colorBalanceSettingElem = document.getElementById("colorBalance-setting");
            if (colorBalanceSettingElem) {
                colorBalanceSettingElem.classList.remove('selected-tool');
            }
        }
    }
}